import React from 'react';
import {FastFieldProps} from 'formik/dist/FastField';

import {TemplateRCDataFromRequest} from 'core/RateConfirmation/types';
import {isRegionNA} from 'core/RateConfirmation/modules/translate';

import TemplateEU from './components/TemplateEU';
import TemplateNA from './components/TemplateNA';

import styles from './styles.module.scss';

type OwnProps = {
    template: TemplateRCDataFromRequest;
    children: React.ReactElement<FastFieldProps>;
};

const RateConfirmation: React.FC<OwnProps> = ({template, children}) => {
    const isNATemplate = isRegionNA(template);

    return (
        <div className={styles.rc}>
            {isNATemplate ? (
                <TemplateNA data={template}>{children}</TemplateNA>
            ) : (
                <TemplateEU data={template}>{children}</TemplateEU>
            )}
        </div>
    );
};

export default RateConfirmation;
